export const timetableCacheSchema = {
    title: 'timetable_cache',
    version: 1,
    description: 'Cache for stop timetables (expires in 1 day)',
    type: 'object',
    primaryKey: 'id',
    properties: {
        id: {type: 'string'},
        stop_id: {type: 'string'},
        route_id: {type: 'string'},
        itineraries_timetables: {
            type: 'array',
            items: {type: 'object'},
        },
        fetched_at: {type: 'number'},
    },
    required: ['id', 'stop_id', 'route_id', 'itineraries_timetables', 'fetched_at'],
} as const;
